/**
 * ToolDisclaimer — shared "Freeze Dry Academy provides this as a support
 * tool, not a professional service" warning. Drop it at the top of every
 * calculator / tool so operators always see the responsibility notice.
 *
 * Also renders an optional intro panel above the disclaimer.
 */

import React from 'react';
import { AlertTriangle, Info } from 'lucide-react';

export default function ToolDisclaimer({ intro, testid = 'tool-disclaimer' }) {
  return (
    <div className="space-y-3 no-print">
      {intro && (
        <div
          className="rounded-lg border border-primary/30 bg-primary/5 p-4 text-sm"
          data-testid={`${testid}-intro`}
        >
          <div className="flex items-start gap-2">
            <Info className="w-4 h-4 mt-0.5 shrink-0 text-primary" />
            <div className="space-y-1">
              {typeof intro === 'string'
                ? <p className="text-foreground/90">{intro}</p>
                : intro}
            </div>
          </div>
        </div>
      )}
      <div
        className="rounded-lg border-2 border-red-500/60 bg-red-500/5 p-4 text-sm text-foreground/85 flex items-start gap-3"
        data-testid={testid}
      >
        <AlertTriangle className="w-8 h-8 mt-0.5 shrink-0 text-red-600" strokeWidth={2.5} />
        <div className="space-y-2">
          <div>
            <span className="font-bold uppercase tracking-wider text-red-700 dark:text-red-500">
              Support tool notice —
            </span>{' '}
            Freeze Dry Academy provides this tool as a planning support only. Cost
            estimates, calorie targets, freeze-dry timelines, and nutrition values
            are AI-generated approximations, not certified figures. Verify every
            number against your local grocer, a certified lab, and your machine's
            documented specs before making purchase, safety, or commercial-labelling
            decisions.
          </div>
          <div className="text-base font-bold text-red-700 dark:text-red-400">
            Responsibility for any action taken based on this output rests entirely with the user.
          </div>
        </div>
      </div>
    </div>
  );
}
